// The purpose of this file is to store all types that are defined on Owl
// They will be exported under the module `OWL` so you would use OWL.SubmissionStatus instead of SubmissionStatus
// Not everything is in here yet because it would require chaning a lot of files but we shoudl slow move types into here

// Types coudl be broken up into multiple files and exported as submodules
// For example there coudl be a `submissions.ts` and a type used from that file would look like OWL.Submission.Status

import { LineType } from '../types';

export enum SubmissionStatus {
  Initialized = 'initialized',
  Ignored = 'ignored',
  Ready = 'ready',
  AutomationRunning = 'automation_running',
  AwaitingMfaCode = 'awaiting_mfa_code',
  AwaitingClientMfaInit = 'awaiting_client_to_initiate_mfa',
  AutoMfaOptionSelect = 'auto_mfa_option_select',
  AutoMfaCodeEntry = 'auto_mfa_code_entry',
  AutoSecurityQuestionSelect = 'auto_security_question_select',
  AutoSecurityQuestionAnswer = 'auto_security_question_answer',
  ReturnedToClient = 'returned_to_client',
  Complete = 'complete',
  AgentInitiated = 'agent_initiated',
  WrongDocuments = 'wrong_documents_uploaded_by_client',
}

/** Owl state for login attempt */
export enum LoginAttemptStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Unknown = 'unknown',
  NotImplemented = 'not_implemented',
  PartiallyImplemented = 'partially_implemented',
}

export interface Carrier {
  name: string;
  slug: string;
  websiteUrl: string;
  loginUrl: string;
  registrationUrl: string;
  passwordResetUrl: string;
  exampleDecPageUrl: string | null;
  sort: number | null;
  logo: string;
  manualSubmissionOnly: boolean;
  parentCarrierSlug: string | null;
  hasChildren: boolean;
  sometimesRequiresMfa: boolean;
  isUnavailable: boolean;
}

//=========================//
//    Requests
//=========================//

export interface CreateLoginAttempt {
  clientId: string;
  submissionId: string;
  loginAttemptId: string;
  /** INS-1391: Pigeon validation-owner generation; Owl rejects older ones (412) */
  generation?: number;
  status: LoginAttemptStatus;
  insuranceLine: LineType;
  startTime: number;
  endTime: number;
  metadata?: Record<string, any>;
  data?: {
    username: string;
    password: string;
    additionalFields: Record<string, any>;
  };
}
